/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import CircularProgress from "@mui/material/CircularProgress"; // Add this import
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";

// Argon Dashboard 2 PRO MUI components
import SocialConnectPage from "0.Mine/0.Components/Onboarding/ConnectAll";
import IntegrationDashboard from "0.Mine/0.Components/Onboarding/Container/AccountsForm/IntegrationDashboard";
import { useOmniChat } from "0.Mine/1.Hooks/CRM/omnichat";
import { UseMetricool } from "0.Mine/1.Hooks/social/metricool";
import { useBusinessContext } from "0.Mine/2.Context/businessContext";
import ArgonBox from "components/ArgonBox";
import ArgonButton from "components/ArgonButton";
import ArgonTypography from "components/ArgonTypography";

// Argon Dashboard 2 PRO MUI example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import BusinessNavbar from "examples/Navbars/DashboardNavbar/businessNavbar";

const ConnectAccounts = () => {
  return (
    <DashboardLayout>
      <ConnectAccountsWithContext />
    </DashboardLayout>
  );
};

function ConnectAccountsWithContext() {
  const { session } = useBusinessContext();
  const [showIframe, setShowIframe] = useState(true);
  const [qrCode, setQrCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // Add loading state
  const { startWhatsappSession } = useOmniChat();
  const { getConnectedSocials } = UseMetricool();
  const [showMetricool, setShowMetricool] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      if (session) {
        setIsLoading(true); // Start loading
        try {
          const response = await startWhatsappSession(session.selectedBusiness.id);
          console.log("Whatsapp session started:", response);
          setQrCode(response.data.qr_image);
          const metricoolResponse = await getConnectedSocials(session.selectedBusiness.id);
          console.log("Metricool connected socials:", metricoolResponse);
          if (metricoolResponse.length > 0) {
            //setShowMetricool(false);
          }
        } catch (error) {
          console.error("Error starting WhatsApp session:", error);
        } finally {
          setIsLoading(false); // End loading regardless of outcome
        }
      }
    };

    fetchData();
  }, [session]);

  return (
    <ArgonBox>
      <BusinessNavbar />
      <ArgonBox mt={3} mb={14} position="relative">
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={8}>
            <ArgonBox textAlign="center">
              <ArgonTypography variant="h2" fontWeight="bold">
                Porta il tuo business ovunque!
              </ArgonTypography>
              <ArgonBox mt={1}>
                <ArgonTypography variant="body2">
                  Collega social media, Google Calendar e metodi di pagamento in pochi clic.
                  <br />
                  Gestisci clienti, appuntamenti e incassi senza perdere neanche
                  un&apos;opportunit&agrave;.
                  <br />
                  Conquista la scena, resta sempre connesso, incassa senza limiti!
                </ArgonTypography>
              </ArgonBox>

              {/* Toggle Button */}
              <ArgonBox mt={2}>
                <ArgonButton
                  variant="contained"
                  color="primary"
                  onClick={() => setShowIframe(!showIframe)}
                >
                  {showIframe ? "Mostra i Social" : "Mostra Whatsapp"}
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>
          </Grid>
        </Grid>

        <ArgonBox mt={4}>
          {showIframe ? (
            <>
              {isLoading ? (
                <ArgonBox
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  minHeight="300px"
                >
                  <CircularProgress color="info" />
                  <ArgonTypography ml={2} variant="button" color="text">
                    Caricamento QR Code WhatsApp...
                  </ArgonTypography>
                </ArgonBox>
              ) : qrCode ? (
                <ArgonBox display="flex" justifyContent="center">
                  <ArgonTypography variant="h6" fontWeight="bold" mb={2}>
                    Scansiona il QR Code nella tua applicazione Whatsapp sul tuo dispositivo per
                    iniziare a mandare e ricevere messaggi
                  </ArgonTypography>
                
                  <ArgonBox
                    component="img"
                    src={qrCode}
                    alt="QR Code WhatsApp"
                    sx={{
                      maxWidth: "300px",
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: 3,
                      border: "1px solid #e0e0e0",
                      p: 3,
                      bgcolor: "white",
                    }}
                  />
                </ArgonBox>
              ) : (
                <ArgonBox textAlign="center" p={3}>
                  <ArgonTypography variant="body2" color="text">
                    Impossibile caricare il QR Code. Riprova più tardi.
                  </ArgonTypography>
                </ArgonBox>
              )}
            </>
          ) : showMetricool ? (
            <SocialConnectPage />
          ) : (
            <ArgonBox
              textAlign="center"
              p={4}
              bgcolor="white"
              borderRadius="lg"
              boxShadow={3}
              maxWidth="600px"
              mx="auto"
            >
              <ArgonTypography variant="h5" color="dark" mb={2} fontWeight="medium">
                Connessioni social non disponibili
              </ArgonTypography>
              <ArgonTypography variant="body2" color="text" mb={3}>
                Contatta il tuo project manager per aggiungere ulteriori social al tuo account.
              </ArgonTypography>
              <ArgonButton
                variant="gradient"
                color="info"
                onClick={() => (window.location.href = "/dashboards/crm")}
              >
                Torna alla dashboard
              </ArgonButton>
            </ArgonBox>
          )}
        </ArgonBox>
        <Footer />
      </ArgonBox>
    </ArgonBox>
  );
}

export default ConnectAccounts;

/*

            <ArgonBox
              sx={{
                height: "800px", // Fixed height 
                width: "100%",
                border: "1px solid #e0e0e0",
                borderRadius: "10px",
                overflow: "hidden",
                boxShadow: 3
              }}
            >
              <iframe
                src={iframe}
                width="100%"
                height="100%"
                style={{ border: "none" }}
                title="Metricool Integration"
                allowFullScreen
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
              />
            </ArgonBox>
          
            */
